import type { AnalyticsAttributes } from '@atlassian/analytics-bridge/types';
import type { TemplateForm } from '@atlassian/proforma-common-core/form';
import { FormQuestionType } from '@atlassian/proforma-form-renderer/proforma-form';

export const buildFormCreatedAnalyticsAttributes = (
	templateForm: TemplateForm,
): AnalyticsAttributes => ({
	templateFormId: templateForm.design.settings.templateId,
	formId: 1,
	hasCascadingFields: Object.values(templateForm.design.questions).some(
		(question) => question.type === FormQuestionType.ChoiceCascading,
	),
});
